import React, { useState, useRef, useEffect } from "react";

export const EditableRow = ({ index, ...props }) => {
    return <tr {...props} />;
};

export const EditableCell = ({
    title,
    record,
    dataIndex,
    inputType,
    handleSave,
}) => {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(record[dataIndex]);
    const inputRef = useRef(null);

    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        setValue(record[dataIndex]);
    };

    const save = () => {
        toggleEdit();
        handleSave({ ...record, [dataIndex]: value });
    };

    if (editing) {
        return (
            <div className="flex items-center gap-1">
                {inputType === "number" ? (
                    <input
                        ref={inputRef}
                        type="number"
                        className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                        value={value ?? ""}
                        onChange={(e) => setValue(e.target.value === "" ? "" : Number(e.target.value))}
                    />
                ) : inputType === "date" ? (
                    <input
                        ref={inputRef}
                        type="date"
                        className="px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                        value={value || ""}
                        onChange={(e) => setValue(e.target.value)}
                    />
                ) : (
                    <input
                        ref={inputRef}
                        type="text"
                        className="w-24 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                        value={value ?? ""}
                        onChange={(e) => setValue(e.target.value)}
                    />
                )}
                <button type="button" onClick={save} className="text-red-500 hover:text-red-700">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                </button>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-1 pr-6">
            <span>{record[dataIndex]}</span>
            <button type="button" onClick={toggleEdit} className="text-gray-400 hover:text-gray-600">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                </svg>
            </button>
        </div>
    );
};
